import KendoStockChartMixin from './KendoStockChartMixin'

export default {
    name: 'kendo-stockchart',
    mixins: [ KendoStockChartMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/index.js